import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import { config } from '@config/config';

import { initializeValidator, ValidatorContext } from '@validation/validator';

import { initializeStore } from '@store';

import App from './App';

const store = initializeStore();
const validator = initializeValidator();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <ValidatorContext.Provider value={validator}>
      <BrowserRouter basename={config.basename}>
        <SnackbarProvider>
          <App />
        </SnackbarProvider>
      </BrowserRouter>
    </ValidatorContext.Provider>
  </Provider>
);
